import React from 'react'
import StepBoxes from './StepBoxes'
import Charts from './Charts'
const Home = () => {
    return (
        <div className="apk-home home-section">
            <div className="stepper-container">
                <StepBoxes />
            </div>
            <div className="statistics">
                <Charts />
            </div>

        </div>
    )
}

export default Home